import { useState } from 'react';
import { useOptionalSession } from '../../app/providers/session-context';
import useFormTableFields from './useFormTableFields';
import { filtersFromFormSchemas, filterModuleRows, isFilterActive } from './moduleFilters';

/** Future modules only supply their form schema, records and optional custom-field loader. */
export default function useModuleFilters({ schema, rows = [], listCustomFields, customFormKeys, customFields = [], relations, scope: moduleScope }) {
  const { currentUser } = useOptionalSession();
  const schemas = Array.isArray(schema) ? schema : [schema];
  const scope = `${currentUser?.tenantId || ''}:${currentUser?.id || ''}:${moduleScope || schemas.map((item) => item?.id).join(':')}`;
  const [state, setState] = useState({ scope, values: {} });
  const values = state.scope === scope ? state.values : {};
  const fields = useFormTableFields(customFormKeys || schemas.map((item) => item?.id), listCustomFields);
  const groups = filtersFromFormSchemas(schemas, { rows, relations, customFields: [...fields.definitions, ...customFields] });
  return {
    groups, values, error: fields.error,
    hasActiveFilters: groups.some((group) => isFilterActive(values[group.key], group)),
    onChange: (key, value) => setState((previous) => ({ scope, values: { ...(previous.scope === scope ? previous.values : {}), [key]: value } })),
    onReset: () => setState({ scope, values: {} }),
    filterRows: (items) => filterModuleRows(items, groups, values),
  };
}
